import React, { useState } from "react";
import { Input } from "reactstrap";

const Checkbox = (props) => {
  const { value, onChange } = props;
  const [val, setVal] = useState(value);

  const handleChange = (e) => {
    const {
      target: { value },
    } = e;
    const val = value === "true" || false;
    setVal(!val);
    if (onChange) onChange(e);
  };

  return (
    <Input
      type="checkbox"
      value={val}
      checked={val}
      disabled={value}
      onChange={handleChange}
    />
  );
};
export default Checkbox;
